import React from "react";

const Drawer = ({
	isOpen,
	onClose,
	onBackgroundChange,
	onGridBackgroundChange,
}) => {
	if (!isOpen) return null;

	return (
		<div className="fixed top-0 right-0 h-full w-64 bg-white shadow-lg p-4 flex flex-col">
			<h2 className="text-lg font-bold">Settings</h2>
			<label className="mt-4">Background Image</label>
			<input
				type="file"
				accept="image/*"
				onChange={(e) =>
					onBackgroundChange(URL.createObjectURL(e.target.files[0]))
				}
				className="border p-1 mt-2"
			/>

			<label className="mt-4">Grid Background Image</label>
			<input
				type="file"
				accept="image/*"
				onChange={(e) =>
					onGridBackgroundChange(URL.createObjectURL(e.target.files[0]))
				}
				className="border p-1 mt-2"
			/>

			<button
				onClick={onClose}
				className="mt-4 bg-red-500 text-white p-2 rounded"
			>
				Close
			</button>
		</div>
	);
};

export default Drawer;
